var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React from "react";
import { Table } from "react-bootstrap";
import GenericSidebar from "../../../../../shared-library/components/GenericSidebar";
import ServiceRequestData from "./ServiceRequestData";
import di from "@frameworks/salesjourney/components/Features/ClientDetails/di/serviceLocator";
import { useSelector } from "react-redux";
import moment from "moment";
import Errormsg from "@frameworks/web/components/generic/errorMsg";
import Loader from "../../../../../shared-library/components/Loader";
var ServiceRequestTable = function (props) {
    var columnList = [
        "Service Request Id",
        "Account Code",
        "Client Name ",
        "Client Tier",
        "Category",
        "Call Type",
        "Sub Type",
        "Assigned Team",
        "Assigned User",
        "Status",
        "Sub Status",
        "Created User",
        "Created Date",
        "Closed Date",
        "Due Date",
        "Process Time",
        "Jira TicketId",
    ];
    var keysPopulatedInSRTable = [
        "ServiceRequestID",
        "AcCode",
        "AcName",
        "ClientTier",
        "CategoryName",
        "CallTypeName",
        "SubTypeName",
        "AssignTeamName",
        "AssinIndividualName",
        "Status",
        "SubStatus",
        "CreatedUser",
        "CreatedDate",
        "AssignDate",
        "DueDate",
        "TimeTaken",
        "TicketID",
    ];
    var _a = __read(React.useState(false), 2), viewSr = _a[0], setViewSr = _a[1];
    var _b = __read(React.useState(false), 2), viewInnerTable = _b[0], setViewInnerTable = _b[1];
    var _c = __read(React.useState(false), 2), loader = _c[0], setLoader = _c[1];
    var _d = __read(React.useState([]), 2), qrcData = _d[0], setQRCData = _d[1];
    var _e = __read(React.useState([]), 2), searchData = _e[0], setSearchData = _e[1];
    var selectedAcount = useSelector(function (state) { return state.Clients.ClientSearch.reducersData.selected; });
    var _f = __read(React.useState(), 2), selectedSR = _f[0], setSelectedSR = _f[1];
    var getDataFromQRC = function () { return __awaiter(void 0, void 0, void 0, function () {
        var requestPayload;
        return __generator(this, function (_a) {
            setLoader(true);
            requestPayload = {
                Pan: selectedAcount.pan,
                FromDate: moment(props.startDate).format("yyyy-MM-DD"),
                ToDate: moment(props.endDate).format("yyyy-MM-DD"),
                //isStatusCode: "CurrentApprover",
            };
            di.clients
                .getDataFromQRC(requestPayload)
                .then(function (apiresponse) {
                setQRCData(apiresponse);
                setLoader(false);
            })
                .catch(function (error) {
                setQRCData([]);
                setLoader(false);
            });
            return [2 /*return*/];
        });
    }); };
    React.useEffect(function () {
        if ((props === null || props === void 0 ? void 0 : props.searchText) !== undefined &&
            (props === null || props === void 0 ? void 0 : props.searchText) !== null &&
            (props === null || props === void 0 ? void 0 : props.searchText) !== "") {
            searchRecordFromWithinData(props === null || props === void 0 ? void 0 : props.searchText);
        }
    }, [props === null || props === void 0 ? void 0 : props.searchText]);
    React.useEffect(function () {
        if (selectedAcount && selectedAcount.accountCode)
            getDataFromQRC();
    }, [selectedAcount.accountCode, props.startDate, props.endDate]);
    var searchRecordFromWithinData = function (searchText) {
        setLoader(true);
        if (qrcData && (qrcData === null || qrcData === void 0 ? void 0 : qrcData.length) > 0) {
            var localSearchData_1 = [];
            qrcData.map(function (record) {
                var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s;
                console.log("search details", searchText, (_a = record === null || record === void 0 ? void 0 : record.Status) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(searchText === null || searchText === void 0 ? void 0 : searchText.toLowerCase()));
                if (((_b = record.ServiceRequestID) === null || _b === void 0 ? void 0 : _b.toLowerCase().includes(searchText.toLowerCase())) ||
                    ((_c = record.AcCode) === null || _c === void 0 ? void 0 : _c.toLowerCase().includes(searchText.toLowerCase())) ||
                    ((_d = record.AcName) === null || _d === void 0 ? void 0 : _d.toLowerCase().includes(searchText.toLowerCase())) ||
                    ((_e = record.ClientTier) === null || _e === void 0 ? void 0 : _e.toLowerCase().includes(searchText.toLowerCase())) ||
                    ((_f = record.CategoryName) === null || _f === void 0 ? void 0 : _f.toLowerCase().includes(searchText.toLowerCase())) ||
                    ((_g = record.CallTypeName) === null || _g === void 0 ? void 0 : _g.toLowerCase().includes(searchText.toLowerCase())) ||
                    ((_h = record.SubTypeName) === null || _h === void 0 ? void 0 : _h.toLowerCase().includes(searchText.toLowerCase())) ||
                    ((_j = record.AssignTeamName) === null || _j === void 0 ? void 0 : _j.toLowerCase().includes(searchText.toLowerCase())) ||
                    ((_k = record.AssinIndividualName) === null || _k === void 0 ? void 0 : _k.toLowerCase().includes(searchText.toLowerCase())) ||
                    ((_l = record.Status) === null || _l === void 0 ? void 0 : _l.toLowerCase().includes(searchText.toLowerCase())) ||
                    ((_m = record.SubStatus) === null || _m === void 0 ? void 0 : _m.toLowerCase().includes(searchText.toLowerCase())) ||
                    record.CreatedUser.toLowerCase().includes(searchText.toLowerCase()) ||
                    ((_o = record.CreatedDate) === null || _o === void 0 ? void 0 : _o.toLowerCase().includes(searchText.toLowerCase())) ||
                    ((_p = record.AssignDate) === null || _p === void 0 ? void 0 : _p.toLowerCase().includes(searchText === null || searchText === void 0 ? void 0 : searchText.toLowerCase())) ||
                    ((_q = record.DueDate) === null || _q === void 0 ? void 0 : _q.toLowerCase().includes(searchText === null || searchText === void 0 ? void 0 : searchText.toLowerCase())) ||
                    ((_r = record.TimeTaken) === null || _r === void 0 ? void 0 : _r.toLowerCase().includes(searchText === null || searchText === void 0 ? void 0 : searchText.toLowerCase())) ||
                    ((_s = record.TicketID) === null || _s === void 0 ? void 0 : _s.toLowerCase().includes(searchText === null || searchText === void 0 ? void 0 : searchText.toLowerCase()))) {
                    localSearchData_1.push(record);
                }
            });
            if ((searchData === null || searchData === void 0 ? void 0 : searchData.length) > 0) {
                localSearchData_1 = Array.from(new Set(localSearchData_1));
            }
            setSearchData(localSearchData_1);
            setLoader(false);
        }
    };
    var returnIterableResultArray = function () {
        var data = qrcData;
        if (!!props.searchText && props.searchText !== "") {
            data = searchData;
        }
        return data;
    };
    var returnIterableResultArrayCondition = function () {
        var result = false;
        if (!!props.searchText &&
            (props === null || props === void 0 ? void 0 : props.searchText) !== "" &&
            (searchData === null || searchData === void 0 ? void 0 : searchData.length) > 0) {
            result = true;
        }
        else if (qrcData && qrcData.length > 0) {
            result = true;
        }
        return result;
    };
    var tableTD = function (x) {
        if (x)
            return keysPopulatedInSRTable.map(function (y) {
                var _a;
                return (React.createElement("td", { className: "ellipsis", title: (_a = x[y]) === null || _a === void 0 ? void 0 : _a.toString() },
                    React.createElement("span", null, x[y] ? x[y] : "-")));
            });
    };
    var showNoDataMsg = function () {
        var showNoDataMsg = false;
        if (!!(props === null || props === void 0 ? void 0 : props.searchText) &&
            (props === null || props === void 0 ? void 0 : props.searchText) !== "" &&
            (searchData === null || searchData === void 0 ? void 0 : searchData.length) === 0) {
            showNoDataMsg = true;
        }
        else if ((qrcData === null || qrcData === void 0 ? void 0 : qrcData.length) === 0) {
            showNoDataMsg = true;
        }
        return showNoDataMsg;
    };
    return (React.createElement(React.Fragment, null,
        loader ? (React.createElement("div", { className: "position-relative client-loader" },
            React.createElement(Loader, null))) : (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "table-responsive m-2" },
                React.createElement(Table, { className: "lead-table service-request " },
                    React.createElement("thead", { className: "DMSansMedium_12_500 txt_primaryGrey" },
                        React.createElement("tr", null, columnList.map(function (column, idx) {
                            return React.createElement("th", { key: idx }, column);
                        }))),
                    React.createElement("tbody", { className: "DMSanN_14_400 txt_blackOne1" }, returnIterableResultArrayCondition() &&
                        returnIterableResultArray().map(function (x, i) {
                            return (React.createElement("tr", { className: "hand_cursor", key: i, onClick: function () {
                                    setViewSr(true);
                                    setSelectedSR(x);
                                } },
                                tableTD(x),
                                React.createElement("td", { className: "align-bottom" },
                                    React.createElement("i", { className: "edel-icon-arrow-down", onClick: function (e) {
                                            setViewInnerTable(!viewInnerTable);
                                            e.stopPropagation();
                                        } }))));
                        })))),
            showNoDataMsg() && React.createElement(Errormsg, { msg: "No Data Found" }))),
        React.createElement(GenericSidebar, { delay: 10, parentClassname: "sr-table-sidebar", header: React.createElement("div", { className: "bg_aqua_white sr-sidebar-head DMSans_16_500 txt_blackOne1" }, "Service Request"), body: React.createElement(ServiceRequestData, { data: selectedSR }), footer: "", openKey: viewSr, setOpenKey: setViewSr, arrowClose: true })));
};
export default ServiceRequestTable;
